export enum EntityActionType
{
    Add = 0,
    Update = 1,
    Remove = 2
}
